// extracted by mini-css-extract-plugin
export var videoContainer = "index-module--videoContainer--nEt8j";
export var video = "index-module--video---UeD9";